<script lang="ts">
  import type { Atelier } from '../../stores/creation.svelte'

  let { atelier }: { atelier: Atelier } = $props()

  const classes = $derived(atelier.referentiel.classes)
  const capacites = $derived(atelier.referentiel.capacites)
  const nomDeCompetence = (id: string) =>
    atelier.referentiel.competences.find((c) => c.id === id)?.nom ?? id

  /** Le nom d'affichage d'une Caractéristique, jamais son identifiant. */
  const nomDeCarac = (id: string) =>
    atelier.referentiel.caracteristiques.find((c) => c.id === id)?.nom ?? id
</script>

<p class="chapo">
  La Classe relève de 5 le plafond de deux Caractéristiques — et ce relèvement
  <em>s'ajoute</em> à celui de la Région. Elle octroie aussi les Compétences
  avancées et les Capacités de son Rang 1.
</p>

<div class="cartes">
  {#each classes as c (c.id)}
    <button
      type="button"
      class="carte"
      class:active={c.id === atelier.feuille.classe}
      onclick={() => atelier.choisirClasse(c.id)}
    >
      <span class="nom">{c.nom}</span>
      {#if c.faction}<span class="faction">{c.faction}</span>{/if}
      <span class="resume">{c.resume}</span>
      <span class="releve">
        +{c.releve_de} au plafond de {c.caracteristiques_relevees.map(nomDeCarac).join(' et ')}
      </span>
      <dl class="rang">
        <dt>Compétences</dt>
        <dd>
          {#each Object.entries(c.competences_octroyees) as [id, valeur], i (id)}
            {i > 0 ? ', ' : ''}{nomDeCompetence(id)} <span class="valeur">{valeur}</span>
          {/each}
        </dd>
        <dt>Capacités</dt>
        <dd>{c.capacites.map((id) => capacites[id]?.nom ?? id).join(', ')}</dd>
      </dl>
    </button>
  {/each}
</div>

<style>
  .chapo {
    color: var(--ink-soft);
    max-width: 62ch;
    margin: 0 0 calc(var(--pas) * 4);
  }
  .cartes {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(19rem, 1fr));
    gap: calc(var(--pas) * 2);
  }
  .carte {
    display: grid;
    gap: calc(var(--pas) * 0.5);
    text-align: left;
    background: var(--surface);
    border: 1px solid var(--line);
    border-radius: var(--r);
    padding: calc(var(--pas) * 3);
    color: var(--ink);
    cursor: pointer;
    font: inherit;
  }
  .carte:hover {
    border-color: var(--line-fort);
  }
  .carte.active {
    border-color: var(--accent);
    box-shadow: inset 3px 0 0 var(--accent);
  }
  .nom {
    font-family: 'Cinzel', serif;
    font-size: 1.05rem;
  }
  .faction {
    font-size: 0.75rem;
    color: var(--gold);
    letter-spacing: 0.05em;
  }
  .resume {
    font-size: 0.85rem;
    color: var(--ink-soft);
  }
  .releve {
    text-transform: uppercase;
    font-size: 0.72rem;
    color: var(--gold);
    margin-top: var(--pas);
  }
  .rang {
    margin: calc(var(--pas) * 2) 0 0;
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 0 calc(var(--pas) * 2);
    font-size: 0.78rem;
  }
  dt {
    color: var(--ink-soft);
    font-family: 'Cinzel', serif;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-size: 0.65rem;
    padding-top: 0.15em;
  }
  dd {
    margin: 0;
  }
  .valeur {
    color: var(--gold);
    font-variant-numeric: tabular-nums;
  }
</style>
